/**
 * Dashboard Page - Home view for StarNexus platform
 * @module components/starnexus/dashboard/DashboardPage
 */

import React from 'react';
import ContentLayout from '@amzn/awsui-components-console/content-layout';
import Header from '@amzn/awsui-components-console/header';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Grid from '@amzn/awsui-components-console/grid';

import { AIInsights } from './AIInsights';
import { MetricsOverview } from './MetricsOverview';
import { ActivityFeed } from './ActivityFeed';
import { QuickActions } from './QuickActions';
import { ProcessingSnapshot } from './ProcessingSnapshot';

export const DashboardPage: React.FC = () => {
  return (
    <ContentLayout
      header={
        <Header
          variant="h1"
          description="Monitor your data processing pipelines and system health"
        >
          Dashboard
        </Header>
      }
    >
      <SpaceBetween size="l">
        <AIInsights />
        <MetricsOverview />
        <Grid
          gridDefinition={[
            { colspan: { default: 12, m: 8 } },
            { colspan: { default: 12, m: 4 } }
          ]}
        >
          <SpaceBetween size="l">
            <ActivityFeed />
            <ProcessingSnapshot />
          </SpaceBetween>
          <QuickActions />
        </Grid>
      </SpaceBetween>
    </ContentLayout>
  );
};

export default DashboardPage;
